import React, { FC } from "react";
import { useContent } from "contexts/contentContext/contentContext.js";
import Tooltip from "components/Elements/Tooltip/Tooltip";

type ConditionalTooltipProps = {
  children: React.ReactNode;
  condition: boolean;
  tooltipTextKey: string;
};

const ConditionalTooltip: FC<ConditionalTooltipProps> = ({
  children,
  condition,
  tooltipTextKey,
}) => {
  const { getHtmlByKey } = useContent();
  return condition ? (
    <Tooltip tooltipText={getHtmlByKey(tooltipTextKey)}>{children}</Tooltip>
  ) : (
    children
  );
};

export default ConditionalTooltip;
